// skills/combat/index.js
// Combat skill registration

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderCombatUI, updateCombatUI, initCombatUI } from './combatUI.js';

skillRegistry.register('combat', {
    id: 'combat',
    name: 'Combat',
    icon: '\u2694\ufe0f', // Crossed swords emoji
    iconImage: 'assets/icons/skill_icons/combat.png',
    tabs: [
        { id: 'tier1', name: 'Wilderness', default: true },
        { id: 'tier2', name: 'Depths' },
        { id: 'tier3', name: 'Forbidden' },
        { id: 'tier4', name: 'Pyre Veil' }
    ],
    render: (params) => renderCombatUI(params),
    update: () => updateCombatUI(),
    init: () => initCombatUI()
});
